/*
 *  Document   : client-company-data.js
 *  Author     : Exapoint
 *
 */

// Import required modules

import ExaHelpers from "../exa_helpers";

export default class ClientCompanyData {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ClientCompanyData"] = this;
        this.init();

        this.$latInput = $('[name="lat"]');
        this.$lngInput = $('[name="lng"]');
        this.$googleMapsResult = $('[name="google_maps_result"]');

        ExaHelpers.addScript(
            'https://maps.googleapis.com/maps/api/js?libraries=places&callback=Function.prototype&key=' + googleMapsApiKey,
            function () {
                this.geocoder = new google.maps.Geocoder();
                this.$form.on('submit', function (e) {
                    let address = this.$addressLine1.val() + ' ' + this.$postcode.val() + ' ' + this.$city.val() + ' ' + this.$country.val();
                    e.preventDefault();
                    $.when(
                        this.geocoder.geocode({'address': address}, function (results, status) {
                            this.$latInput.val(results[0].geometry.location.lat());
                            this.$lngInput.val(results[0].geometry.location.lng());
                            this.$googleMapsResult.val(JSON.stringify(results));

                            if (this.$form.valid()) {
                                this.$form.unbind('submit').submit();
                            }
                        }.bind(this))
                    );
                }.bind(this));
            }.bind(this)
        );

        if (jsVars.showEmptyMissionsAlert) {
            this.showEmptyMissionsAlert();
        }
    }

    showEmptyMissionsAlert() {
        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        e.fire({
            title: '',
            text: '',
            icon: "success",
            showCancelButton: 1,
            customClass: {confirmButton: "btn btn-success m-1", cancelButton: "btn btn-danger m-1"},
            confirmButtonText: jsVars.missionsText,
            cancelButtonText: jsVars.closeText,
            html: jsVars.emptyMissionsText,
            preConfirm: function (e) {
                window.location = jsVars.missionsUrl;
            }
        })
    }

    zefixSearchButtonInit() {
        this.zefixSearchButton.on('click', () => {
            // Get input value
            let inputValue = this.companyNameInput.val();
            $.ajax({
                type: 'POST',
                url: jsVars.zefixSearch,
                data: {
                    input: inputValue,
                    _token: Laravel.csrfToken,
                },
            }).then((response) => {
                if (typeof response.error == "undefined") {
                    this.addItemsToDropdown(response);
                } else {
                    this.companyNameDropdownMenu.html('');
                    this.companyNameDropdownMenu.append(
                        `<a class="dropdown-item company-name-dropdown-item" href="javascript:void(0)"">${response.error}</i></a>`
                    );
                    this.companyNameDropdownPrependButton.click();
                }
            }).fail(() => {
            });
        });
    }

    selectCompany(enterpriseId) {
        $.ajax({
            type: 'POST',
            url: jsVars.companySelect,
            data: {
                enterpriseId: enterpriseId,
                _token: Laravel.csrfToken,
            },
        }).then((response) => {
            this.fillInputData(response);
        }).fail(() => {
        });
    }

    fillInputData(companyData) {
        this.companyNameInput.val(companyData['name']);
        this.$addressLine1.val(companyData['address_line_1']);
        this.companyEnterpriseIdInput.val(companyData['chid']);
        this.$isZefixCompany.val('true');
        this.$city.val(companyData['city']);
        this.$postcode.val(companyData['postcode']);
        if (typeof companyData['phone_number'] !== "undefined" && companyData['phone_number'] !== "") {
            $('[name="phone_number"], [name="phone_number_intl"]').val(companyData['phone_number']).prop('readonly', true);
        }
        if (typeof companyData['branch_id'] !== "undefined" && companyData['branch_id'] !== "") {
            this.$branch.find(`option[value="${companyData['branch_id']}"]`).prop('selected', true);
            this.$branch.find('option:not(:selected)').prop('disabled', true);
        }

        let countryOption = this.$country.find("option[value='" + companyData['country_id'] + "']");
        if (countryOption.length !== 0) {
            countryOption.prop('selected', true);
        }

        this.toggleFieldsReadOnly(!companyData['isConsultant']);
    }

    addItemsToDropdown(items) {
        this.companyNameDropdownMenu.html('');
        items.forEach((item) => {
            this.companyNameDropdownMenu.append(
                `<a class="dropdown-item company-name-dropdown-item" href="javascript:void(0)"
data-enterprise-id="${item.chid}">${item.name}, ${item.legalSeat} (${item.chid})</i></a>`
            );
        });

        this.companyNameDropdownPrependButton.click();
    }

    toggleFieldsReadOnly(isZefixCompany) {
        // Disable fields and options user can't change
        this.$form.find('input:not([name="phone_number"]):not([name="phone_number_intl"]), select').prop('readonly', isZefixCompany);
        if (isZefixCompany) {
            this.$country.find('option:not(:selected)').prop('disabled', true);
            this.$country.find('option:selected').prop('disabled', false);
        } else {
            this.$country.find('option').prop('disabled', false);
        }
    }

    initElements() {
        this.zefixSearchButton = $('#company-name-zefix-search-button');
        this.companyNameDropdownMenu = $('#company-name-dropdown-menu');
        this.companyNameDropdownPrependButton = $('#company-name-dropdown-prepend-button');
        this.companyNameInput = $('#company-name-input');
        this.companyEnterpriseIdInput = $('#company-enterprise-id-input');
        this.$isZefixCompany = $('[name="is_zefix_company"]');
        this.$addressLine1 = $('[name="address_line_1"]');
        this.$city = $('[name="city"]');
        this.$country = $('[name="country_id"]');
        this.$postcode = $('[name="postcode"]');
        this.$branch = $('[name="branch_id"]');
        this.$resetCompanyData = $('#button-reset-company-data');
        this.$form = $('#company-edit-form');
    }

    initEvents() {
        this.zefixSearchButtonInit();
        $(document).on('click', '.company-name-dropdown-item', (e) => {
            // Get enterprise id
            let enterpriseId = $(e.target).data('enterprise-id');
            if (typeof enterpriseId !== "undefined") {
                this.selectCompany(enterpriseId);
            }
        });

        this.$resetCompanyData.on('click', function (e) {
            this.$form.find('input[name!="_token"]:not(.btn), select').val('');
            this.toggleFieldsReadOnly(false);

            $('[name="phone_number"], [name="phone_number_intl"]').prop('readonly', false);
            this.$branch.find('option').prop('disabled', false);

            this.companyNameDropdownMenu.html('');
        }.bind(this));

        this.companyNameInput.on('keydown', function (event) {
            if (event.which === 13 || event.keyCode === 13) {
                this.zefixSearchButton.trigger('click');
                return false;
            }
            return true;
        }.bind(this));
    }

    init() {
        this.initElements();
        this.initEvents();

        ExaHelpers.validation();
        this.initValidation();

        this.initRatingsTabClient();
    }

    initValidation() {
        $('.js-validation').validate({
            ignore: [],
            rules: {
                'chid': {
                    required: true,
                },
                'status': {
                    required: true,
                },
                'address_line_1': {
                    required: true,
                },
                'city': {
                    required: true,
                },
                'postcode': {
                    required: true,
                },
                'country_id': {
                    required: true,
                },
                'phone_number_intl': {
                    required: true,
                    intlTelNumber: true,
                },
                'branch_id': {
                    required: true,
                },
            },
        });

        // Init Validation on Select2 change
        $('.js-select2:not(.skip-validation)').on('change', e => {
            $(e.currentTarget).valid();
        });
    }

     initRatingsTabClient() {


        this.ratingsTable = this.ratingsTable || $('#company-rating-client .js-dataTable-full-pagination').DataTable({
            ajax: jsVars.datatablesRatingAjax,
            order: [[4, "asc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "submitter_id",
                    render: function (data, type, row) {
                        //return `${data ?? ""}`;
                        return `${row.submitter.first_name} ${row.submitter.last_name}`;
                    }
                },
                {
                    data: "mission_id",
                    render: function (data, type, row) {
                        //return `${data ?? ""}`;
                        const href = jsVars.editMissionUrl.replace(':mission-id', row.mission_id);
                        const content = row.mission.titre ?? row.mission.professions
                        let html = `<a href="${href}">${content}</a>`;
                        return html;
                    }
                },
                {
                    data: "clarity_of_instructions_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "allocated_time_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "atmosphere_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "comment",
                    render: function (data, type, row) {
                        //return `${ExaHelpers.ratingToIcons(data)}`;
                        return `${data ?? ""}`;
                    }
                },
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });

    }

}
